import { Card } from '@mui/material';
import { AdvicesCard } from './advices-card';
import { AGE_NAMES, FROM_FOUR_TO_FIVE_TITLE, SIX_AGE_TITLE } from '../../../consts/ages';
import {
    FROM_FOUR_TO_FIVE,
    SIX_AGE,
    FROM_FOUR_TO_FIVE_HOT,
    FROM_FOUR_TO_FIVE_COLD
} from '../../../consts/adviceAgeFourSix';

export const UserAdvicesCard = ({ child, temperature, advice }) => {
    const babyAge = AGE_NAMES.filter(({ text }) => text === child.age);

    return (
        <>
            {babyAge.length !== 0 ?
                <Card key={child.id}
                    sx={{
                        maxWidth: 635,
                        margin: '0 auto 16px',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)'
                    }}>
                    <h3 className='advices-wrapper_title'>{child.name}</h3>
                    <AdvicesCard title={babyAge[0].text} text={advice(babyAge[0].value)[0].advice} />
                </Card> :
                (child.age === FROM_FOUR_TO_FIVE_TITLE) ?
                    <Card key={child.id}
                        sx={{
                            maxWidth: 635,
                            margin: '0 auto 16px',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)'
                        }}>
                        <h3 className='advices-wrapper_title'>{child.name}</h3>
                        <AdvicesCard title={FROM_FOUR_TO_FIVE_TITLE} text={FROM_FOUR_TO_FIVE}
                            textTemp={temperature <= 15 ? FROM_FOUR_TO_FIVE_COLD : FROM_FOUR_TO_FIVE_HOT} />
                    </Card> :
                    (child.age === SIX_AGE_TITLE) ?
                        <Card key={child.id}
                            sx={{
                                maxWidth: 635,
                                margin: '0 auto 16px',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)'
                            }}>
                            <h3 className='advices-wrapper_title'>{child.name}</h3>
                            <AdvicesCard title={SIX_AGE_TITLE} text={SIX_AGE} />
                        </Card> : <></>
            }
        </>
    )
}